<template>
  <div class="personageStatistics">
    <header>
      <i class="el-icon-arrow-left" @click="goBack()"></i>
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :replace="true" :to="{ path: '' }">{{name}}的统计</el-breadcrumb-item>
        <el-breadcrumb-item v-if="type">{{type}}</el-breadcrumb-item>
      </el-breadcrumb> -->
      <div>
        <span :style="{color:type ? '#AAAAAA' : '#343434'}" style="cursor: pointer;" @click="active=''">{{name}}的统计</span>
        <i class="el-icon-arrow-right" v-show="type"></i>
        <span style="font-weight: bold;color: #454545" v-show="type">{{type}}</span>
      </div>
    </header>
    <div style="padding-left:30px;height: calc(100% - 52px);overflow: auto;">
      <ul class="tabBox">
        <li @click="active='text'"><i class="tab-icon text-icon"></i>翻译字数：<span>{{transWordNum}}</span></li>
        <li @click="active='speed'"><i class="tab-icon speed-icon"></i>翻译速度（字/分钟）：<span>{{Math.round(transCostTime)}}</span></li>
        <li @click="active='fluency'"><i class="tab-icon fluency-icon"></i>流畅度（平均）：<span>{{fluencyScore}}</span>
          <el-tooltip class="item" effect="dark" content="分值：0-5分" placement="bottom">
            <i class="doubt-icon"></i>
          </el-tooltip>
        </li>
        <li @click="active='accuracy'"><i class="tab-icon accuracy-icon"></i>准确度（平均）：<span>{{accuracyScore}}</span>
          <el-tooltip class="item" effect="dark" content="分值：0-5分" placement="bottom">
            <i class="doubt-icon"></i>
          </el-tooltip>
        </li>
      </ul>
      <div style="height: calc(100% - 50px);">

        <Translate v-if="active==='text'"></Translate>
        <Speed v-else-if="active==='speed'"></Speed>
        <Fluency v-else-if="active==='fluency'"></Fluency>
        <Accuracy v-else-if="active==='accuracy'"></Accuracy>
        <Charts v-else @setDomain="setDomain"></Charts>
      </div>
    </div>

  </div>
</template>

<script>
import Charts from "@/common/Statistics/InterpreterStatistics/Charts";
import Translate from "@/common/Statistics/InterpreterStatistics/Translate";
import Speed from "@/common/Statistics/InterpreterStatistics/Speed";
import Fluency from "@/common/Statistics/InterpreterStatistics/Fluency";
import Accuracy from "@/common/Statistics/InterpreterStatistics/Accuracy";
import eventBus from '@/assets/js/eventBus'
export default {
  name: "personageStatistics",
  data() {
    return {
      name: "",
      accuracyScore: null,
      fluencyScore: null,
      transCostTime: 0,
      transWordNum: null,
      domainCode: "",
      active: "",
      // type: ""
    };
  },
  components: {
    Charts,
    Translate,
    Speed,
    Fluency,
    Accuracy
  },
  computed: {
    type() {
      let type;
      switch (this.active) {
        case "text":
          type = "翻译字数"
          break;
          case "speed":
          type = "翻译速度"
          break;
        case "fluency":
          type = "翻译流畅度"
          break;
        case "accuracy":
          type = "翻译准确度"
          break;
        default:
          type = ""
          break;
      }
      return type
    }
  },
  created() {
    this.userId = this.$route.query.id;
    this.name = this.$route.query.name;
    this.queryAvgScore();
    this.queryAvgCost();
  },
  methods: {
    goBack() {
      this.$router.replace({name:"reportForm",params:{activeName:"InterpreterStatistics"}})
    },
    setDomain(data) {
      this.domainCode = data;
      this.queryAvgScore();
      this.queryAvgCost();
    },
    async queryAvgScore() {
      const params = {
        domainCode: this.domainCode,
        userId: this.userId
      }
      let url = "/api/v1/taskScore/queryAvg"
      const { result, resultCode } = await this.catReq1Service(url, params)
      if (resultCode === '1') {
        this.accuracyScore = result.accuracyScore;
        this.fluencyScore = result.fluencyScore;
      }
    },
    async queryAvgCost() {
      const params = {
        domainCode: this.domainCode,
        userId: this.userId
      }
      let url = "/api/v1/taskCost/queryAvg"
      const { result, resultCode } = await this.catReq1Service(url, params)
      if (resultCode === '1') {
        result.transCostTime ? this.transCostTime = result.transWordNum / (result.transCostTime / 60) : this.transCostTime = result.transCostTime;
        this.transWordNum = result.transWordNum;
      }
    },

  }
};
</script>
<style lang="less" scoped>
.personageStatistics {
  height: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 0 20px;
  header {
    height: 40px;
    line-height: 40px;
    display: flex;
    align-items: center;
    padding-top: 12px;
    .el-icon-arrow-left {
      position: relative;
      left: -6px;
      cursor: pointer;
    }
  }

  .tabBox {
    display: flex;
    flex-wrap: wrap;
    li {
      display: flex;
      align-items: center;
      font-weight: bold;
      color: #566087;
      margin-top: 20px;
      max-width: 25%;
      padding-right: 6vw;
      cursor: pointer;
      span {
        margin-left: 10px;
        color: #2c88e6;
      }
    }
    .tab-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    .text-icon {
      background: url("../../assets/imgs/project/number_of_words_translated.png")
        center center no-repeat;
      background-size: cover;
    }
    .speed-icon {
      background: url("../../assets/imgs/project/translation_speed.png") center
        center no-repeat;
      background-size: cover;
    }
    .fluency-icon {
      background: url("../../assets/imgs/project/fluency.png") center center
        no-repeat;
      background-size: cover;
    }
    .accuracy-icon {
      background: url("../../assets/imgs/project/accuracy.png") center center
        no-repeat;
      background-size: cover;
    }
    .doubt-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-left: 8px;
      background: url("../../assets/imgs/project/doubt.png") center center
        no-repeat;
      background-size: cover;
    }
  }
}
</style>